<template>
<section>
    <div class="container pt-7">
        <div class="row">
            <!-- Blog list START -->
            <div class="col-xl-8 mb-5 mb-xl-0">
                <!-- Title -->
                <h4 class="mb-4">{{ $t('topHighlights') }}</h4>
                <!-- Blog item -->
                <article v-for="article in articles" :key="article.id" class="card bg-secondary bg-opacity-50 card-hover-transition p-3 mb-4">
                    <div class="row">
                        <div class="col-md-4">
                            <!-- Image -->
                            <img :src="BACK_URL + article.cover" class="img-fluid card-img" :alt="article.title">
                        </div>
                        <div class="col-md-8">
                            <!-- Content -->
                            <div class="card-body d-flex flex-column h-100 ps-0 pe-3">
                                <!-- Badge -->
                                <div class="d-flex gap-2 mb-3">
                                    <span class="badge bg-pink">{{ article.category }}</span>
                                    <span class="badge bg-white text-dark">{{ article.read_time }} min</span>
                                </div>
                                <!-- Title -->
                                <h6 class="card-title mb-3 mb-md-0">{{ article.title }}</h6>
                                <div class="d-sm-flex justify-content-between align-items-center mt-auto">
                                    <p class="mb-4 mb-sm-2 heading-color fw-semibold">By {{ article.user_name }}</p>

                                    <router-link :to="`/blogs/articles/${article.id}/${generateSlug(article.title)}`" class="icon-link icon-link-hover stretched-link">
                                        {{ $t('readMore') }}<i class="bi bi-arrow-right"></i>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div>

            <div class="col-xl-3 ms-auto">
                <div class="row">
                    <div class="col-sm-6 col-lg-3 col-xl-12">
                        <div class="card bg-transparent">
                            <div class="card-header border-bottom bg-transparent px-0">
                                <p class="lead fw-bold heading-color mb-0">{{ $t('categories') }}</p>
                            </div>
                            <div class="card-body px-0">
                                <ul>
                                    <li v-for="(count, category) in categoryCounts" :key="category">
                                        {{ category }} : ( {{ count }} )
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-3 col-xl-12">
                        <div class="card bg-transparent">
                            <div class="card-header border-bottom bg-transparent px-0">
                                <p class="lead fw-bold heading-color mb-0">{{ $t('follow_us_on') }}</p>
                            </div>
                            <div class="card-body px-0">
                                <ul class="list-inline mb-0 text-center justify-content-center">
                                    <!-- Instagram -->
                                    <li class="list-inline-item">
                                        <a class="btn btn-icon bg-instagram" href="https://www.instagram.com/visennia_/profilecard/?igsh=MXRobGJic2s3anZneA==">
                                            <i class="bi bi-instagram lh-base"></i>
                                        </a>
                                    </li>
                                    <!-- Facebook -->
                                    <li class="list-inline-item">
                                        <a class="btn btn-icon bg-facebook" href="https://www.facebook.com/profile.php?id=61574224162359">
                                            <i class="bi bi-facebook lh-base"></i>
                                        </a>
                                    </li>
                                    <!-- TikTok -->
                                    <li class="list-inline-item">
                                        <a class="btn btn-icon bg-tiktok" href="https://www.tiktok.com/@visenniamedia?_t=ZT-8ud6AKxhdTq&_r=1">
                                            <i class="bi bi-tiktok lh-base"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import axios from "@/api/axios.js";
import {
    BACK_URL
} from "@/article_cover.js";

export default {
    data() {
        return {
            articles: [],
            BACK_URL,
            categoryCounts: {},
        };
    },
    mounted() {
        this.fetchArticles();
    },
    methods: {
        async fetchArticles() {
            try {
                // Get language from localStorage
                const language = localStorage.getItem('lang') || 'en';

                const response = await axios.get(`/get-article/last?language=${language}`);

                this.articles = response.data;
                this.countArticlesByCategory();
            } catch (error) {
                console.error('Error fetching articles:', error);
            }
        },

        countArticlesByCategory() {
            this.categoryCounts = {};

            this.articles.forEach(article => {
                const category = article.category;

                if (this.categoryCounts[category]) {
                    this.categoryCounts[category]++;
                } else {
                    this.categoryCounts[category] = 1;
                }
            });
        },

        generateSlug(title) {
            return title
                .toLowerCase()
                .replace(/\s+/g, '-')
                .replace(/[^a-z0-9-]/g, '');
        },
    }
};
</script>
